<template>
  <div class="row">
    <div class="col-12 col-lg-12 m-auto">
      <form class="multisteps-form__form">
        <technical-assistance :class="activeStep === 0 ? activeClass : ''" @next-step="nextStep" />
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import TechnicalAssistance from "./components/TechnicalAssistanceForm.vue";

const activeClass = "js-active position-relative";
const activeStep = ref(0);
const formSteps = 3;

const nextStep = () => {
  if (activeStep.value < formSteps) {
    activeStep.value += 1;
  }
};
</script>